import { get } from "lodash";
import { useState } from "react";
import { useTranslation } from "react-i18next";
import { IoDuplicateOutline } from "react-icons/io5";
import { MdArrowBackIos, MdArrowForwardIos } from "react-icons/md";
import Button from "shared/components/Button";
import Card from "shared/components/Card";
import Header from "shared/components/Header";
import Loading from "shared/components/Spin";
import { NAME_SPACES } from "shared/locales/constants";
import DownloadOrSend from "./Widgets/DownloadOrSend";
import InsurancePlanCard from "./Widgets/InsurancePlans";

const View = ({
  project,
  onSubscribe,
  onDownload,
  onSendQuote,
  data,
  onBack,
  loading,
  openModal,
  setOpenModal,
  duplicateProject,
  hideDetail,
  setHideDetail,
}) => {
  const { locked, fields, subscriptions, contract } = project;
  const { t } = useTranslation(NAME_SPACES.PRIVATE.BROKER.PROJECT);
  const [selectedModules, setSelectedModules] = useState(
    project?.fields?.upsells || [],
  );
  const DETAIL = t("DETAIL", { returnObjects: true });

  return (
    <div>
      <Header
        key={"header"}
        title={DETAIL.TEMPLATES.COMPARISON.TITLE_LMF}
        actions={[]}
      />
      <div className="comparison-container">
        <div className="d-flex justify--end">
          {locked && project?.expired ? (
            <>
              <Button
                onClick={() => duplicateProject()}
                type="primary--outlined"
              >
                <IoDuplicateOutline size={16} />
                {DETAIL.TEMPLATES.COMPARISON.DUPLICATE_PROJECT}
              </Button>
            </>
          ) : (
            <Button
              onClick={() => setOpenModal(true)}
              type="primary--outlined"
              disabled={project?.expired}
            >
              {DETAIL.TEMPLATES.COMPARISON.NEXT}
              <MdArrowForwardIos size={16} />
            </Button>
          )}
        </div>
        <Card
          type="custom"
          size="full"
          title={DETAIL.TEMPLATES.COMPARISON.CARD_TITLE_LMF}
          subtitle={DETAIL.TEMPLATES.COMPARISON.CARD_SUBTITLE_LMF}
          head
        >
          <DownloadOrSend
            data={data}
            open={openModal}
            onClose={() => setOpenModal(false)}
            onDownload={onDownload}
            onSendQuote={onSendQuote}
            fields={fields}
            insurancePlans={get(project, "subscriptions", []).map(
              ({ insurancePlan }) => insurancePlan?.id,
            )}
            selectedModules={selectedModules}
            project={project}
          />

          {loading ? (
            <Loading />
          ) : (
            <div className="insurance-plans-grid">
              {data?.map(({ insurancePlan, cost, currency }) => (
                <InsurancePlanCard
                  key={insurancePlan.id}
                  insurancePlan={insurancePlan}
                  subscriptions={subscriptions}
                  issuanceDate={get(contract, "issuanceDate")}
                  isRIA={get(project, "ria", false)}
                  cost={cost}
                  currency={currency}
                  translation={DETAIL.TEMPLATES.COMPARISON}
                  onSubscribe={onSubscribe}
                  expired={project.expired}
                  locked={project.locked}
                  selectedModules={selectedModules}
                  setSelectedModules={setSelectedModules}
                  project={project}
                />
              ))}
            </div>
          )}
        </Card>

        <Button
          onClick={onBack}
          type="secondary--link"
          disabled={project.locked}
        >
          <MdArrowBackIos size={16} />
          {DETAIL.TEMPLATES.COMPARISON.PREVIOUS}
        </Button>
      </div>
    </div>
  );
};

export default View;
